import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

/**
 * To access query string parameters,
 * `const { param1, param2 } = useQueryParams();`
 */

const defaultOptions = { ignoreQueryPrefix: true };

const useQueryParams = options => {
  const { search } = useLocation();

  return useMemo(() => {
    return qs.parse(search, { ...defaultOptions, ...options });
  }, [options, search]);
};

export default useQueryParams;
